import { Button } from '@components/Button';
import BottomSheet, { BottomSheetAPI } from '@mobileComponents/BottomSheet';
import { useParams } from '@solidjs/router';
import { createAppStore } from '@mobileStore/createAppStore';
import {
  addCustomerGeneralComment,
  customerDetailsStore,
  updateCustomerDetailsState,
} from '@mobileStore/customer';
import { PlusIcon } from '@atgfr8/icons';
import { TextField } from '@atgfr8/atg-ui-tailwind';
import { mobileIsAdmin } from '@mobileUtils/roleUtils';
import { createSignal } from 'solid-js';

const AddComment = () => {
  const params = useParams();
  const [commentVal, setCommentVal] = createAppStore<{
    comment: string;
  }>(
    {
      comment: '',
    },
    'customerCollectionCommentVal',
    true,
  );
  const [isProcessing, setIsProcessing] = createSignal(false);
  let sheetAPI: BottomSheetAPI | undefined;

  const handleSubmit = () => {
    const comment = commentVal.comment.trim();

    if (comment.length > 0) {
      void handleAddNewComment();
    }
  };

  const handleAddNewComment = async () => {
    setIsProcessing(true);
    const payload = {
      objectId: Number(params.id),
      comment: commentVal.comment.trim(),
      type: mobileIsAdmin() ? 'Admin' : 'User',
    };

    const res = await addCustomerGeneralComment(payload);
    if (res?.isSuccess) {
      const customerDetails = customerDetailsStore.customer;
      setIsProcessing(false);
      setCommentVal('comment', '');
      updateCustomerDetailsState({
        comments: [res.value, ...customerDetails.comments],
      });
      sheetAPI?.close();
    }
  };
  return (
    <>
      <BottomSheet
        title="Add Comment"
        ref={(api) => (sheetAPI = api)}
        onClose={() => setCommentVal('comment', '')}
        trigger={
          <Button
            variant="contained"
            color="info"
            label="Add"
            size="sm"
            class="bg-white! text-[#026ea1]!"
            startIcon={<PlusIcon size={20} />}
            dataTestId="customer-info-add-comment"
          />
        }
      >
        <TextField
          multiline
          label="Comment"
          rows={2}
          value={commentVal.comment}
          placeholder="Add a message"
          onChange={(value) => setCommentVal('comment', value)}
          class="font-normal! text-[14px]! [&_textarea]:font-normal! [&_textarea]:text-[14px]!"
          disabled={isProcessing()}
          dataTestId="customer-collection-comments-new-textAreaField"
        />
        <Button
          label="Add Comment"
          variant="contained"
          size="sm"
          onClick={() => handleSubmit()}
          class="w-full p-1! text-[14px]!"
          isLoading={isProcessing()}
          startIcon={<PlusIcon size={20} />}
          dataTestId="customer-collection-comments-add-button"
          disabled={
            isProcessing() ||
            commentVal.comment === '' ||
            commentVal.comment.trim().length === 0
          }
        />
      </BottomSheet>
    </>
  );
};

export default AddComment;
